import { GET_IPD_DASHBOARD_CASE_TYPE } from "../../../constants/asyncActionsType";
import createAsyncThunkForSlice from "../../../utils/utils";
import { getAllIpdDashboardCase } from "./ipdDashBoardCrud";

export const getIpdDashboardCaseList = createAsyncThunkForSlice(
  GET_IPD_DASHBOARD_CASE_TYPE,
  getAllIpdDashboardCase
);
